module.exports = __webpack_public_path__ + "RG.svg?d24970158022c68e46236f5f2764e393";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/RG.svg
// module id = 65
// module chunks = 0